import { IRBushItem } from '../../../../../../common/types/map';

export const updateBalloons = (rbushItems: IRBushItem[], balloonManager: YMaps.BalloonManager) => {
  for (const rbushItem of rbushItems) {
    balloonManager.updateBalloonProperties(rbushItem.feature.id, rbushItem.feature.properties);
  }
};
